module.exports = __webpack_public_path__ + "assets/img/BETFAIR.487764dd.png";